import React from 'react';
import { ErrorContainer } from '../StyledComponents/Div';

/**
 * Shown when GET /settings fails and there is no cached copy to fall back on, so the app
 * cannot start at all. Previously this state rendered null forever -- a blank page with
 * nothing logged anywhere.
 *
 * Deliberately not the shared ErrorView: its "Go back" button is useless when nothing has
 * loaded yet. Reloading is the only useful action.
 */
const BootstrapError = () => (
  <ErrorContainer>
    <h1>Unity could not start</h1>
    <p>
      We could not load the application settings. This is usually temporary.{' '}
      <button onClick={() => window.location.reload()} type="button">
        Reload
      </button>{' '}
      to try again. If it keeps happening, please contact{' '}
      <a href="mailto:helpdesk@dallasmarketcenter.com">Help Desk</a>.
    </p>
  </ErrorContainer>
);

export default BootstrapError;
